// Stills per coworld address root under public/home/stills/<root>/1..n.webp; keep the counts in step with the images.
export const stillCounts: Readonly<Record<string, number>> = {
  agricogla: 5,
  "atari-57": 1,
  "atari-cabinet": 1,
  babel: 1,
  battlecode: 5,
  battleroyale: 1,
  "board-gauntlet": 1,
  botpaint: 1,
  bullwhip: 1,
  bw: 1,
  "call-to-adventure": 1,
  chemistry: 1,
  chorus: 1,
  cogball: 1,
  cogchemists: 1,
  cogherence: 5,
  cogiavelli: 1,
  cogmud: 1,
  cognames: 1,
  cogolf: 1,
  cogplomacy: 1,
  cogriculture: 5,
  "cogs-against-humanity": 5,
  "cogs-vs-clips": 3,
  cogsul: 1,
  cogtan: 5,
  coguire: 5,
  coins: 1,
  "collab-cooking": 1,
  "commons-family": 1,
  contagion: 1,
  "continuous-control": 1,
  "cooperative-hunting": 1,
  cosino: 5,
  "coworld-mtg": 1,
  crafter: 1,
  crewrift: 5,
  daycare: 1,
  "derks-gym": 1,
  dreamwire: 1,
  ecos: 1,
  eleusis: 1,
  "emerg-ant": 1,
  escrow: 1,
  factorio: 1,
  "factory-commons": 1,
  firm: 1,
  flatland: 1,
  focus: 1,
  "fog-of-war-boards": 1,
  "fruit-market": 1,
  garble: 1,
  "gen-generals-io": 1,
  generals: 3,
  "generals-competition": 12,
  "gift-refinements": 1,
  gnomic: 1,
  "gods-of-the-arena": 12,
  "goofspiel-oshi-zumo": 1,
  "grf-football": 1,
  "grid-wars": 1,
  gridlock: 1,
  halite: 1,
  hanabi: 5,
  harvestbench: 1,
  heartleaf: 5,
  "hidden-agenda": 1,
  "hide-and-seek": 1,
  hive: 1,
  "infinite-blocks": 5,
  jumper: 5,
  "knights-archers": 1,
  lantern: 1,
  ledger: 1,
  "liars-cog": 5,
  "liars-dice": 1,
  "light-vs-dark": 1,
  lighthouse: 1,
  "lux-ai": 1,
  "magent-battle": 1,
  "matrix-games": 1,
  meadow: 5,
  minecraft: 1,
  minigrid: 1,
  moba: 5,
  muster: 5,
  "negotiation-games": 1,
  nethack: 1,
  nightshift: 5,
  nmmo: 5,
  nomic: 1,
  "nomic-fable": 5,
  overfished: 1,
  paintarena: 5,
  paintbot: 5,
  "paintbot-cdx": 5,
  "paintbot-pw": 12,
  "paintbot-royal": 12,
  parley: 5,
  "particle-worlds": 1,
  "physics-bodies": 1,
  pistonball: 1,
  "planet-wars": 5,
  polis: 1,
  polychess: 1,
  "polymarket-coworld": 1,
  pommerman: 1,
  procgen: 1,
  proxywar: 5,
  raid: 1,
  rumor: 1,
  "rware-warehouse": 1,
  "smac-starcraft-micro": 1,
  "snake-royale": 1,
  sokoban: 1,
  "sugarscape-2": 12,
  "sumo-traffic-signals": 1,
  tandem: 1,
  territory: 1,
  tribunal: 1,
  "trick-taking": 1,
  "vizdoom-deathmatch": 1,
  "walker-waterworld": 1,
  werecog: 1,
  "zero-sum": 5,
};
